import { Badge } from "@/components/ui/badge";
import type { VerificationStatus } from "@/domain";
import { cn, typography } from "@/utilities/tailwind-utils";

type Props = { status: VerificationStatus };

export function StatusBadge({ status }: Props) {
  switch (status) {
    case "approved":
      return (
        <Badge
          variant="active"
          hideIcon
          className={cn(
            typography.textCaptionMedium12,
            "text-success uppercase"
          )}
        >
          Approved
        </Badge>
      );
    case "under_review":
    case "resubmitted":
      return (
        <Badge
          variant="cancelled"
          hideIcon
          className={cn(
            typography.textCaptionMedium12,
            "text-warning uppercase"
          )}
        >
          {status === "resubmitted" ? "Resubmitted" : "Under Review"}
        </Badge>
      );
    case "rejected":
    case "pending":
      return (
        <Badge
          variant="upcoming"
          hideIcon
          className={cn(typography.textCaptionMedium12, "text-error uppercase")}
        >
          {status === "pending" ? "Pending Review" : "Rejected"}
        </Badge>
      );
    default:
      return <Badge variant="outline">Unknown</Badge>;
  }
}
